import { Box, Divider, Theme, useMediaQuery } from '@mui/material';
import { useState } from 'react';

import { CaptureId, CurrentSessionProps, DrawerTypes, IdV4, MapCapturePiece } from '../../types';
import ItemsList from './components/ItemsList';
import PieceView from './components/PieceView';
import ReviewStats from './components/Stats';
import { prepareItems } from './helpers';
import { containerSx, internalContainerSx, leftSx, sxDivider, sxRightContainer } from './styles';
import { ReviewItemsFilterType } from 'src/types/shared';

type Props = {
  mapCapturePiece: MapCapturePiece;
  setDrawer: (type: DrawerTypes) => void;
  onItemClick: (key: CaptureId | null) => void;
  onCropClick: () => void;
  retryFailedPieces: (id: IdV4) => void;
  currentSession: CurrentSessionProps;
  onDeletePiece: () => void;
  cursor: CaptureId | null;
};

const Review = ({
  mapCapturePiece,
  cursor,
  onItemClick,
  currentSession,
  setDrawer,
  onCropClick,
  retryFailedPieces,
  onDeletePiece,
}: Props) => {
  const activePiece = mapCapturePiece[cursor || 0];
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const [filter, setFilter] = useState<null | ReviewItemsFilterType>(null);
  const pieces = Object.values(mapCapturePiece);
  const [search, setSearch] = useState('');

  const activePieceId = activePiece?.id;

  const { items, isActiveInList, ...stats } = prepareItems(pieces, filter, activePieceId, search);

  if (!isActiveInList && activePieceId) onItemClick(null);

  return (
    <Box sx={containerSx}>
      <Box sx={internalContainerSx}>
        <Box sx={leftSx(isMobile, !!activePiece)}>
          <ReviewStats {...stats} total={pieces.length} onFilterClick={setFilter} />
          <ItemsList
            selected={activePieceId}
            onClear={() => setFilter(null)}
            onItemClick={onItemClick}
            items={items}
            filter={filter}
            setSearch={setSearch}
          />
        </Box>
        <Divider sx={sxDivider} orientation="vertical" />
        <Box sx={sxRightContainer(isMobile, !!activePiece)}>
          <PieceView
            onDeletePiece={onDeletePiece}
            onCropClick={onCropClick}
            retryFailedPieces={retryFailedPieces}
            handleBack={() => onItemClick(null)}
            setDrawer={setDrawer}
            capturePiece={activePiece}
            currentSession={currentSession}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Review;
